export function getVisitorId() {
  let visitorId = localStorage.getItem("visitor_id");

  if (!visitorId) {
    visitorId =
      window.crypto?.randomUUID?.() ||
      `visitor_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

    localStorage.setItem("visitor_id", visitorId);
  }

  return visitorId;
}